import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicPageLayout from '../components/layout/PublicPageLayout';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiCheckCircle, FiLock, FiServer, FiActivity } = FiIcons;

const SecurityAuditPage = () => {
  const navigate = useNavigate();

  return (
    <PublicPageLayout 
      title="Sikkerhetsrevisjon" 
      subtitle="Oversikt over sikkerhetstiltak, infrastruktur og revisjoner."
      activePage="/sikkerhet"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        
        {/* Intro */}
        <section className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-green-600">
              <SafeIcon icon={FiShield} className="text-3xl" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Sikkerhetsstatus</h2>
              <p className="text-green-600 font-medium flex items-center gap-2">
                <SafeIcon icon={FiCheckCircle} /> Systemet er operativt og sikret
              </p>
            </div>
          </div>
          <p className="text-gray-600 leading-relaxed">
            HMSVarsling gjennomgår jevnlige sikkerhetsrevisjoner for å sikre at all data behandles i henhold til strengeste standarder for kryptering og tilgangskontroll.
          </p>
        </section>

        {/* Technical Measures */}
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-xl border border-gray-200">
            <SafeIcon icon={FiLock} className="text-blue-600 text-2xl mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-2">Kryptering</h3>
            <p className="text-sm text-gray-600">
              All dataoverføring er kryptert med TLS 1.3 (SSL). Data i hvile er kryptert med AES-256 standard.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl border border-gray-200">
            <SafeIcon icon={FiServer} className="text-purple-600 text-2xl mb-4" />
            <h3 className="text-lg font-bold text-gray-900 mb-2">Infrastruktur</h3>
            <p className="text-sm text-gray-600">
              Servere er plassert i EU (Frankfurt) hos AWS via Supabase, i samsvar med GDPR-krav om datalagring.
            </p>
          </div>
        </div>

        {/* Last Audit */}
        <section className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
            <SafeIcon icon={FiActivity} /> Siste revisjon
          </h3>
          <div className="space-y-4">
            <div className="flex justify-between items-center border-b border-gray-200 pb-2">
              <span className="text-gray-600">Dato</span>
              <span className="font-mono font-medium">01.05.2024</span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-200 pb-2">
              <span className="text-gray-600">Type</span>
              <span className="font-medium">Intern revisjon & Pen-test</span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-200 pb-2">
              <span className="text-gray-600">Status</span>
              <span className="text-green-600 font-bold">Godkjent</span>
            </div>
          </div>
        </section>

        <div className="text-center">
          <button onClick={() => navigate('/')} className="text-blue-600 hover:underline font-medium">
            Tilbake til forsiden
          </button>
        </div>

      </div>
    </PublicPageLayout>
  );
};

export default SecurityAuditPage;